namespace $ { $mol_style_attach( "mol/video/player/player.view.css",
 "[mol_video_player] {\n\tflex: 1 1 auto;\n}\n"
) }